import axios from 'axios';
import { AppUrls, } from './Globals';
import { Config } from './Config';
import { BodySecurityResponseForceEncripted } from '../utils'

export const certificateRequests = {}

certificateRequests.RegisterCertificateType01 = (data) => {
  return axios.post(
    AppUrls.RegisterCertificateType01,
    Config.SetParameters(data, true),
    Config.ConfigAuth()
  ).then(handleResponseForceEncripted)
}

certificateRequests.RegisterCertificateType02 = (data) => {
  return axios.post(
    AppUrls.RegisterCertificateType02,
    Config.SetParameters(data, true),
    Config.ConfigAuth()
  ).then(handleResponseForceEncripted)
}

certificateRequests.GetDocumentCertificate = () => {
  return axios.post(
    AppUrls.GetDocumentAceptance,
    Config.SetParameters("", true),
    Config.ConfigAuth()
  ).then(handleResponseForceEncripted)
}

let handleResponseForceEncripted = (response) => {
  let respObject = BodySecurityResponseForceEncripted(response.data);
  if (!respObject.IsOK) {
    // console.log("respObject:handleResponseForceEncripted ", respObject)
    let responseObject = { message: respObject.Messages + ' ' + (respObject.TansactionId ? respObject.TansactionId : '') + ' ' + (respObject.statusText ? respObject.statusText : '') };
    const error = (respObject.Body || responseObject);
    return Promise.reject(error);
  }
  return respObject;
}